module.exports = __webpack_public_path__ + "img/support_e2.7854f738.png";